export default class AlertUtil {
    private show: boolean = false;

    public open() {
        this.show = true;
    }

    public close() {
        this.show = false;
    }

    public isShow(): boolean {
        return this.show;
    }
}
